export const phpDefaultSource = `<?php
// Deprecated MySQL functions that should be converted to PDO
class DatabaseManager {
    private $connection;
    
    public function connect() {
        // Old MySQL connection - should be converted
        $this->connection = mysql_connect('localhost', 'user', 'pass');
        mysql_select_db('my_database');
    }
    
    public function getUsers() {
        // Old MySQL query - should be converted
        $result = mysql_query("SELECT * FROM users WHERE active = 1");
        $users = array();
        
        // Old fetch method - should be converted
        while ($row = mysql_fetch_array($result)) {
            $users[] = $row;
        }
        
        return $users;
    }
    
    public function getUserById($id) {
        // Another query that needs conversion
        $query = "SELECT * FROM users WHERE id = " . $id;
        $result = mysql_query($query);
        return mysql_fetch_assoc($result);
    }
    
    public function closeConnection() {
        mysql_close($this->connection);
    }
}
?>`;

export const phpDefaultCodemod = `import { type SgRoot } from "@ast-grep/napi";
import type PHP from "@ast-grep/napi/lang/php";

async function transform(root: SgRoot<PHP>): Promise<string> {
  const rootNode = root.root();

  // Find all mysql_query function calls
  const queryNodes = rootNode.findAll({
    rule: {
      kind: "function_call_expression",
      all: [
        {
          has: {
            field: "function",
            kind: "name",
            regex: "^mysql_query$"
          }
        }
      ]
    },
  });

  // Find all mysql_fetch_array function calls
  const fetchArrayNodes = rootNode.findAll({
    rule: {
      kind: "function_call_expression",
      all: [
        {
          has: {
            field: "function", 
            kind: "name",
            regex: "^mysql_fetch_array$"
          }
        }
      ]
    },
  });

  // Find all mysql_fetch_assoc function calls
  const fetchAssocNodes = rootNode.findAll({
    rule: {
      kind: "function_call_expression",
      all: [
        {
          has: {
            field: "function",
            kind: "name", 
            regex: "^mysql_fetch_assoc$"
          }
        }
      ]
    },
  });

  const edits = [
    // Convert mysql_query to PDO query
    ...queryNodes.map(node => {
      // Get the arguments field directly from the function call
      const argsNode = node.field("arguments");
      const argsText = argsNode ? argsNode.text() : "()";
      return node.replace(\`$pdo->query\${argsText}\`);
    }),
    
    // Convert mysql_fetch_array to PDO fetch
    ...fetchArrayNodes.map(node => {
      // Get the first argument (the result variable) from the arguments
      const argsNode = node.field("arguments");
      return node.replace(\`$result->fetch(PDO::FETCH_BOTH)\`);
    }),
    
    // Convert mysql_fetch_assoc to PDO fetch
    ...fetchAssocNodes.map(node => {
      return node.replace(\`$result->fetch(PDO::FETCH_ASSOC)\`);
    })
  ];

  const newSource = rootNode.commitEdits(edits);
  return newSource;
}

export default transform;
`;

export const phpDefaultConfig = `
# Convert deprecated MySQL functions to modern PDO equivalents
# This helps modernize legacy PHP codebases
id: mysql-to-pdo-conversion
language: php
rule:
  any:
    - kind: function_call_expression
      all:
        - has:
            field: function
            kind: name
            regex: ^mysql_query$
    - kind: function_call_expression
      all:
        - has:
            field: function
            kind: name
            regex: ^mysql_fetch_array$
    - kind: function_call_expression
      all:
        - has:
            field: function
            kind: name
            regex: ^mysql_fetch_assoc$
    - kind: function_call_expression
      all:
        - has:
            field: function
            kind: name
            regex: ^mysql_connect$
    - kind: function_call_expression
      all:
        - has:
            field: function
            kind: name
            regex: ^mysql_close$
fix: |
  # Note: ast-grep fix doesn't support conditional logic
  # Use the napi script for proper transformation logic
  $pdo->modernMethod()
`.trim();
